import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FACEBOOK_BASE_URL } from 'modules/Common/consts';

import './FacebookShareButton.scss';

export default class FacebookShareButton extends Component {
  static contextTypes = {
    metrics: PropTypes.object
  };

  static propTypes = {
    dcmp: PropTypes.string,
    page: PropTypes.string
  };

  getHref = () => {
    const {dcmp, page} = this.props;

    const tracking = dcmp ? `?dcmp=sl_social_fb_${dcmp}` : "";
    const encUrl = encodeURIComponent(page + tracking);

    return `${FACEBOOK_BASE_URL}?u=${encUrl}`;
  };

  handleClick = () => {
    if (this.context.metrics) {
      this.context.metrics.track("linkClick", {link: "[Article Share] Facebook"});
    }
  };

  render() {
    return <a href={this.getHref()} onClick={this.handleClick} target="_blank" className={"social-share-button-facebook"}>
      <div className="social-share-button-facebook-image">
        <div className="facebook-icon" title="Share">
          <img src={"/img/icons/facebook.svg"}/>
        </div>
      </div>
      <div className="social-share-button-facebook-text">Share</div>
    </a>;
  }
}



// WEBPACK FOOTER //
// ./modules/Common/components/FacebookShareButton.js